module.exports = __webpack_public_path__ + "static/media/photo1.8978bd41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/photo1.jpg
// module id = 638
// module chunks = 0